import * as React from "react"
import { Link, navigate } from "gatsby"

import PropTypes from "prop-types"

import LogoSvg from '../assets/images/signage.svg';
import BackIcon from '../assets/images/back.svg';

const Header = ({ siteTitle, withBack }) => (
  <header
    className="header"
  >
    <div className={`header-wrap ${withBack ? 'header-between': 'header-center'}`}>
      {withBack && (
        <button
          onClick={() => navigate(-1)}
          className="header-back"
        >
          <BackIcon />
        </button>
      )}
      <h1 className="logo">
        <Link to="/">
          <LogoSvg />
        </Link>
      </h1>
      {withBack && (
        <div className="header-empty" />
      )}
    </div>
  </header>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
